<template>
  <v-container fluid>
    <v-card>
      <v-card-title> Gestión de recetas </v-card-title>
      <!-- Receta cargado -->
      <v-card class="ml-7 mr-7" v-if="Object.keys(trabajoCargado).length > 0">
        <v-card-title>Receta cargada: 
          <span v-if="inicio_ciclo" class="ml-4" :style="`font-weight:normal; font-size:80%; color:green;`">EJECUTANDO</span>
          <span v-else class="ml-4" @click="click_enlace()" :style="`cursor:pointer; font-weight:normal; font-size:80%; color:red`">Tratamiento aún sin iniciar</span>
        </v-card-title>
        
        
        <v-data-table
          :headers="headers"
          :items="[trabajoCargado]"
          hide-default-footer
        >
          <template v-slot:[`item.action`]="">
            <!-- <v-btn v-if="!inicio_ciclo"
              color="green"
              small
              fab
              dark
              @click="ejecutar()"
            >
              <v-icon dark>mdi-play</v-icon>
            </v-btn> -->
            <!-- <v-btn
              color="green"
              fab
              text
              @click="editarTratamientoEnMarcha()"
            >
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn> -->
            <v-btn  v-if="!inicio_ciclo" color="black" fab text  @click="quitarRecetaCargada()">
              <v-icon dark>mdi-close</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-results>
                <span>No hay datos para esta búsqueda</span>
            </template>
        </v-data-table>
      </v-card>
      <v-card class="ml-7 mr-7" v-else>
        <v-card-title> Actualmente no hay ninguna receta cargada </v-card-title>
      </v-card>
      <v-card-text>
        <CrudRecetas
          @eliminar="eliminar"
          @editar="editar"
          @nuevo="nuevo_formulario()"
        />
      </v-card-text>
    </v-card>
    <!-- Formulario para agregar una nueva receta -->
    <FormularioReceta
      v-if="formulario"
      :modo="modo"
      :item_editando="JSON.parse(JSON.stringify(item_editando))"
      @close="guardarCambiosFormulario"
      @cancel="cancel"
    ></FormularioReceta>
  </v-container>
</template>

<script>
import FormularioReceta from "@/components/crud/formularios/FormularioReceta.vue";
import CrudRecetas from "@/components/crud/CrudRecetas.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    CrudRecetas,
    FormularioReceta,
  },
  data() {
    return {
      item_editando: {},
      nuevo: false,
      editando: false,
      headers: [
        { text: "Id", value: "id_receta", align: "center" },
        {
          text: "Nombre",
          value: "name",
          align: "center",
          width: "40%",
        },
        {
          text: "Tipo",
          value: "nombre_tipo_tratamiento",
          align: "center",
          width: "30%",
        },
        { text: "Acción", value: "action", align: "center" },
      ],
      // items: [
      //   {
      //     hora_inicio: "00:00",
      //     hora_final: "00:00",
      //     duracion_parcial: "00:00",
      //     temperatura_objetivo: 300,
      //     tolerancia_max: null,
      //     tolerancia_min: null,
      //     finalizar: "NO",
      //   },
      //   {
      //     hora_inicio: "00:00",
      //     hora_final: "02:30",
      //     duracion_parcial: "02:30",
      //     temperatura_objetivo: 600,
      //     tolerancia_max: 10,
      //     tolerancia_min: 10,
      //     finalizar: "NO",
      //   },
      //   {
      //     hora_inicio: "02:30",
      //     hora_final: "04:30",
      //     duracion_parcial: "02:00",
      //     temperatura_objetivo: 600,
      //     tolerancia_max: 10,
      //     tolerancia_min: 10,
      //     finalizar: "NO",
      //   },
      // ],
    };
  },

  methods: {
    ...mapActions("api", [
      "getRecetas",
      "postReceta",
      "putReceta",
      "putTrabajo",
      "getTrabajo",
      "deleteReceta",
      "putTipoTratamiento",
      "deleteTipoTratamiento",
    ]),
    ...mapActions(["recargarRecetas", "quitarRecetaCargada",'setTrabajo']),
    ...mapActions("nodered", ["doPublish", "doSubscribe"]),
    click_enlace(){
      if (!this.inicio_ciclo) {
        this.$router.push({name:'home'})
      } 
    },
    editarTratamientoEnMarcha() {
      console.log("Ahora se editaria la receta");
      this.editando = true;
      this.item_editando = this.trabajoCargado;
    },
    nuevo_formulario() {
      console.log("nuevo formlario");
      this.nuevo = true;
    },
    async guardarCambiosFormulario(payload) {
      const user = JSON.parse(localStorage.getItem("user"));
      payload.id_usuario = user.id;
      if (this.nuevo == true) {
        console.log("Debo llamar al backend para hacer el post", payload);
        // await this.postTipoTratamiento(payload)
        await this.postReceta(payload);
        this.nuevo = false;
      } else {
        this.editando = false;
        if(payload.id_trabajo){ // si lo modificado es un trabajo
          // this.item_editando = payload
          await this.putTrabajo(payload);
          const trabajo_raw = await this.getTrabajo(payload.id_trabajo);
          const trabajo = trabajo_raw.data;
          console.group();
          console.groupEnd();
          this.setTrabajo(trabajo);
          console.log(this.trabajoCargado);
          this.modificando_trabajo = false;
          let setpoint_inicial = null
          let last_setpoint=null
          let mensaje = {}
          let tramos_a_cargar=[]
          
          payload.detalles.forEach((detalle, index) => {
              if(index==0){
                setpoint_inicial=detalle.setpoint
              }
              //Poner tantos puntos como deltaTimes haya en este segmento
              const diferencia_tiempos_minutos = this.$diferencia_tiempos_minutos( detalle.hora_fin,detalle.hora_inicio)*60
              //Calcular pendiete como
              //(y1-y0)/diferencia_tiempos = (setpoint-last_setpoint)/diferencia_tiempos_minutos
              const pendiete_actual = (last_setpoint)? (detalle.setpoint-last_setpoint)/diferencia_tiempos_minutos:0;

              tramos_a_cargar.push({
                  setpoint:index ==0?parseFloat(detalle.setpoint):parseFloat(payload.detalles[index-1].setpoint),
                  tiempo:diferencia_tiempos_minutos,
                  pendiente:pendiete_actual,
                  tolerancia_max:detalle.tolerancia_max,
                  tolerancia_min:detalle.tolerancia_min
              })
              console.log("ACTUALIACION; ",tramos_a_cargar);

              last_setpoint=detalle.setpoint;
              mensaje = {setpoint_inicial, tramos: tramos_a_cargar}
          })
          this.doPublish({ topic: process.env.VUE_APP_TOPIC_TRABAJO_MODIFICADO,  payload: JSON.stringify(mensaje) });
        }else{// si lo modificado es una receta
          
          // await this.putTipoTratamiento(payload)
          const recet = await this.putReceta(payload);
          console.log(recet);
          console.log("YA HE HECHO EL PUT");        
        }
      }
      await this.recargarRecetas();
    },
    editar(item) {
      console.log("quiere editar", item);
      this.editando = true;
      this.item_editando = item;
      //llama a la accion de abrir formulario pasandole como parametro el item que queremos editar
    },
    async eliminar(item) {
      console.log("quiere eliminar", item);
      await this.deleteReceta(item);
      await this.recargarRecetas();
      //llama a la accion de abrir formulario pasandole como parametro el item que queremos editar
    },
    cancel() {
      this.editando = false;
      this.nuevo = false;
    },
  },
  computed: {
    ...mapState([ "trabajoCargado","inicio_ciclo"]),
    modo() {
      return !this.nuevo ? "editar" : "";
    },
    formulario() {
      return this.nuevo || this.editando;
    },
    // hora_inicio_fin() {
    //   // Inicializa las variables para almacenar la hora_inicio más pequeña y la hora_final más grande
    //   let smallestHoraInicio = Infinity;
    //   let largestHoraFinal = "";

    //   // Itera sobre los elementos para encontrar la hora_inicio más pequeña y la hora_final más grande
    //   this.items.forEach((item) => {
    //     const horaInicioMinutes =
    //       parseInt(item.hora_inicio.split(":")[0]) * 60 +
    //       parseInt(item.hora_inicio.split(":")[1]);
    //     const horaFinalMinutes =
    //       parseInt(item.hora_final.split(":")[0]) * 60 +
    //       parseInt(item.hora_final.split(":")[1]);

    //     if (horaInicioMinutes < smallestHoraInicio) {
    //       smallestHoraInicio = horaInicioMinutes;
    //     }

    //     // Se corrije la lógica para encontrar la hora final más grande
    //     if (
    //       largestHoraFinal === "" ||
    //       horaFinalMinutes >
    //         parseInt(largestHoraFinal.split(":")[0]) * 60 +
    //           parseInt(largestHoraFinal.split(":")[1])
    //     ) {
    //       largestHoraFinal = item.hora_final;
    //     }
    //   });

    //   // Convierte los minutos de vuelta a formato de hora para la hora_inicio más pequeña

    //   const smallestHoraInicioHours = Math.floor(smallestHoraInicio / 60);
    //   const smallestHoraInicioMinutes = smallestHoraInicio % 60;
    //   const formattedSmallestHoraInicio = `${String(
    //     smallestHoraInicioHours
    //   ).padStart(2, "0")}:${String(smallestHoraInicioMinutes).padStart(
    //     2,
    //     "0"
    //   )}`;

    //   console.log("Hora de inicio más pequeña:", formattedSmallestHoraInicio);
    //   console.log("Hora final más grande:", largestHoraFinal);
    //   return { formattedSmallestHoraInicio, largestHoraFinal };
    // },
  },
};
</script>

<style>
.text-center {
  text-align: center;
}

/* Estilos adicionales si son necesarios */
</style>
